import { useControllableState, mergeRefs } from '@doppio/core';
import { IconChevronDown } from '@doppio/icons';
import { Picker } from '@react-native-picker/picker';
import { styled, useDripsyTheme, View } from 'dripsy';
import * as React from 'react';
import { Platform } from 'react-native';
import { useFocus } from 'react-native-web-hooks';
import { FormControl } from '../FormControl';
const TEST_ID = 'doppio-native-select';
const StyledPicker = styled(Picker, {
    themeKey: 'forms',
    defaultVariant: 'select',
})({
    transition: 'outline-offset 0.15s ease',
    outlineStyle: 'solid',
    outlineWidth: 0,
    outlineOffset: 0,
    outlineColor: 'infoBackground',
});
const NativeSelect = React.forwardRef(({ id, label, helperText, labelTooltip, isInvalid, isRequired, isDisabled, defaultValue, onValueChange, items, placeholder, onBlur, onFocus, ...props }, forwardedRef) => {
    const theme = useDripsyTheme().theme;
    const placeholderTextColor = theme.colors['secondaryBackgroundActive'];
    const textColor = theme.colors['text'];
    const [value, setValue] = useControllableState({
        value: props.value,
        defaultValue,
        onChange: onValueChange,
    });
    const localRef = React.useRef(null);
    const isFocusVisible = useFocus(localRef);
    const isPlaceholderSelected = value === '';
    return (React.createElement(FormControl.Group, { formElementId: id, label: label, labelTooltip: labelTooltip, helperText: helperText, isDisabled: isDisabled, isRequired: isRequired, isInvalid: isInvalid }, ({ helperTextId }) => (React.createElement(View, { sx: { position: 'relative' } },
        React.createElement(StyledPicker, { nativeID: id, testID: TEST_ID, ref: mergeRefs([localRef, forwardedRef]), selectedValue: value, sx: {
                ...(isInvalid && { borderColor: 'errorBackground' }),
                ...(isFocusVisible && {
                    outlineWidth: 1,
                    outlineOffset: 2,
                }),
                ...(isPlaceholderSelected && {
                    color: 'secondaryBackgroundActive',
                }),
                ...(isDisabled && {
                    backgroundColor: 'secondaryBackgroundDisabled',
                    borderColor: 'secondaryBackgroundDisabled',
                    color: 'secondaryBackgroundActive',
                    cursor: 'not-allowed',
                    ...(Platform.OS === 'web' && {
                        opacity: 1,
                        '-webkit-text-fill-color': placeholderTextColor,
                    }),
                }),
            }, onValueChange: (itemValue) => setValue(itemValue), enabled: !isDisabled, onBlur: onBlur, onFocus: onFocus, required: isRequired, "aria-required": isRequired, "aria-invalid": isInvalid, "aria-describedby": helperTextId, ...props },
            placeholder && placeholder.label && (React.createElement(Picker.Item, { label: placeholder.label, value: "", enabled: !placeholder.isDisabled, color: placeholderTextColor })),
            items.map((item, index) => (React.createElement(Picker.Item, { label: item.label, value: item.value, key: index, enabled: !item.isDisabled, color: item.isDisabled ? placeholderTextColor : textColor })))),
        React.createElement(View, { sx: {
                position: 'absolute',
                right: 0,
                top: 0,
                bottom: 0,
                width: '$9',
                alignItems: 'center',
                justifyContent: 'center',
            }, pointerEvents: "none" },
            React.createElement(View, { sx: { height: '$6', width: '$6' } },
                React.createElement(IconChevronDown, { ...(isDisabled && { color: 'secondaryBackgroundActive' }) })))))));
});
const NativeSelectCompound = Object.assign(NativeSelect, {
    displayName: 'NativeSelect',
    testID: TEST_ID,
});
export { NativeSelectCompound as NativeSelect };
//# sourceMappingURL=NativeSelect.js.map